import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-product",
  class PredictiveSearchResultProduct extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.result);

      this.innerHTML = `
        <product-summary 
          data-tabindex="-1" 
          data-handle="${this.data.handle}" 
          data-class-list="product-summary--horizontal product-summary--horizontal-until-medium"
        ></product-summary>
      `;

      this.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick() {
      // TODO(SUBS-716 follow-up): fire WYATT.beacon.autocomplete.clickThrough.
      // Autocomplete uses 4 different Searchspring siteIds (products, collections,
      // pages, articles) and the Beacon SDK requires a separate tracker per
      // siteId (no per-call siteId override), so this needs multi-tracker
      // wiring in scripts-searchspring-beacon.liquid before it can fire.

      if (
        !WYATT.config.searchspring.legacyTrackingEnabled ||
        typeof IntelliSuggest === "undefined" ||
        !this.data.intellisuggestData ||
        !this.data.intellisuggestSignature
      ) {
        return;
      }

      IntelliSuggest.clickItem(this, {
        siteId: WYATT.config.searchspring.siteIds.products,
        intellisuggestData: this.data.intellisuggestData,
        intellisuggestSignature: this.data.intellisuggestSignature,
      });
    }
  },
);
